import { Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import {
  RiskScoreRange,
  RangeType,
  RiskScoreRangeFormValues,
} from '../../types';

export const riskLevelsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRiskScoreRanges: build.query<Response<RiskScoreRange>, string>({
      query: (query) => ({
        url: `/v1/risk-score-ranges${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    deleteRiskScoreRanges: build.mutation<
      {
        data: number;
      },
      { ids: string[] }
    >({
      query: (body: { ids: string[] }) => ({
        url: '/v1/risk-score-ranges/batch-delete',
        method: 'DELETE',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createUncategorized: build.mutation<
      {
        data: RiskScoreRange;
      },
      void
    >({
      query: () => ({
        url: '/v1/risk-score-ranges',
        method: 'POST',
        body: {
          name: 'Uncategorized',
          rangeStart: 0,
          rangeEnd: 100,
          action: RangeType.NONE,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createRiskScoreRange: build.mutation<
      {
        data: RiskScoreRange;
      },
      RiskScoreRangeFormValues
    >({
      query: (body: RiskScoreRangeFormValues) => ({
        url: '/v1/risk-score-ranges',
        method: 'POST',
        body: {
          name: body.name,
          rangeStart: Number(body.rangeStart),
          rangeEnd: Number(body.rangeEnd),
          action: body.action,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRiskScoreRange: build.query<{ data: RiskScoreRange }, string>({
      query: (id) => ({
        url: `/v1/risk-score-ranges/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateRiskScoreRange: build.mutation<
      {
        data: RiskScoreRange;
      },
      { body: RiskScoreRangeFormValues; id: string }
    >({
      query: (data: { body: RiskScoreRangeFormValues; id: string }) => ({
        url: `/v1/risk-score-ranges/${data.id}`,
        method: 'PUT',
        body: {
          name: data.body.name,
          rangeStart: Number(data.body.rangeStart),
          rangeEnd: Number(data.body.rangeEnd),
          action: data.body.action,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetRiskScoreRangesQuery,
  useDeleteRiskScoreRangesMutation,
  useCreateUncategorizedMutation,
  useCreateRiskScoreRangeMutation,
  useLazyGetRiskScoreRangeQuery,
  useUpdateRiskScoreRangeMutation,
} = riskLevelsApi;

export const {
  endpoints: {
    getRiskScoreRanges,
    deleteRiskScoreRanges,
    createUncategorized,
    getRiskScoreRange,
    createRiskScoreRange,
    updateRiskScoreRange,
  },
} = riskLevelsApi;
